/*!
 * 7magicexperiments.com 
 *  
 * Art Samvelyan 
 */

(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _exitIntentMobileBugfixAsc = _interopRequireDefault(require("exit-intent-mobile-bugfix-asc"));

var _browserBackButton = _interopRequireDefault(require("browser-back-button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default(delay, scrollsCount, scrollsCountSec) {
  var isMobile = window.innerWidth <= 768;
  var delayTime = delay; //in seconds

  var maxScrollsCount = scrollsCount;
  var maxPopupAttempts = 2;
  var popupAttemptsCounter = 1;
  var scrollEventHandler;
  var body = document.querySelector('body');

  var exitModalEl = function exitModalEl() {
    return document.getElementById('exit-pop');
  };

  var prePurchasePop = document.getElementById('pre-purchase-popup');
  document.addEventListener('click', function (e) {
    if (e.target.closest('.modal-wrapper.active') && (e.target.matches('.close-btn') || e.target.matches('.exit-intent'))) {
      e.preventDefault();

      if (e.target.closest('.modal-wrapper').querySelector('.video')) {
        this.dispatchEvent(new CustomEvent("exitpop-closed", {
          bubbles: true
        }));
      }

      toggleExitPop(e.target);

      if (!e.target.classList.contains('with-scroll')) {
        return false;
      }

      var orientation = window.matchMedia('(orientation:portrait)').matches ? 'portrait' : 'landscape';
      var videoEl = document.querySelector('.video.' + orientation);

      if (!videoEl) {
        return false;
      }

      if ('scrollBehavior' in document.documentElement.style) {
        videoEl.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      } else {
        videoEl.scrollIntoView(false);
      }
    }
  }, false);

  var activateExitPopup = function activateExitPopup(callback) {
    if (prePurchasePop && prePurchasePop.classList.contains('active')) {
      return false;
    }

    if (isMobile) {
      _browserBackButton.default.off(activateExitPopup);

      document.body.removeEventListener('scroll', scrollEventHandler);
    }

    if (callback) {
      typeof callback === 'function' && callback();
    }

    if (popupAttemptsCounter < maxPopupAttempts) {
      maxScrollsCount = scrollsCountSec;
      delayTime = 120; // add 2 minute delay

      activateExitPopFeatures();
    }

    if (!exitModalEl().classList.contains('active')) {
      toggleExitPop();
      popupAttemptsCounter++;
    }
  };

  var initBackButtonFeature = function initBackButtonFeature() {
    _browserBackButton.default.on(activateExitPopup);
  };

  var initWindowScrollFeature = function initWindowScrollFeature() {
    var counter = 0;
    var lastScrollTop = 0;
    var scrollPos = '';

    function resetProperties() {
      counter = 0;
      scrollPos = '';
    }

    scrollEventHandler = function scrollEventHandler() {
      var st = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

      if (st > lastScrollTop) {
        // scroll down
        if (scrollPos === 'up') {
          counter++;
          scrollPos = '';
        } else {
          scrollPos = 'down';
        }
      } else {
        // scroll up
        if (scrollPos === 'down') {
          counter++;
          scrollPos = '';
        } else {
          scrollPos = 'up';
        }
      }

      lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

      if (counter === maxScrollsCount) {
        activateExitPopup();
        resetProperties();
      }
    };

    document.body.addEventListener("scroll", scrollEventHandler, false);
  };

  var initWindowLeaveFeature = function initWindowLeaveFeature() {
    var destroyExitIntent = (0, _exitIntentMobileBugfixAsc.default)({
      eventThrottle: 100,
      showAfterInactiveSecondsDesktop: undefined,
      showAfterInactiveSecondsMobile: undefined,
      showAgainAfterSeconds: 2,
      onExitIntent: function onExitIntent() {
        var handleMouseOver = function handleMouseOver(e) {
          if (e.target.tagName === 'HTML') {
            return false;
          }
        };

        document.addEventListener('mouseover', handleMouseOver, false);
        activateExitPopup(destroyExitIntent);
      },
      debug: false
    });
  };

  var activateExitPopFeatures = function activateExitPopFeatures() {
    setTimeout(function () {
      if (!exitModalEl()) {
        return;
      }

      if (isMobile) {
        initBackButtonFeature();
        initWindowScrollFeature();
      } else {
        initWindowLeaveFeature();
      }
    }, delayTime * 1000);
  };

  activateExitPopFeatures();

  var toggleExitPop = function toggleExitPop() {
    var modalEl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : exitModalEl();
    modalEl.closest('.modal-wrapper').classList.toggle('active');
    body.style.overflow = modalEl.classList.contains('active') ? 'hidden' : 'hidden auto';
  };
};

exports.default = _default;

},{"browser-back-button":7,"exit-intent-mobile-bugfix-asc":8}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default() {
  var countHelp = [308, 295, 295, 283, 277, 273, 272, 258, 255, 201, 201, 194, 182, 182, 179, 178, 177, 158, 158, 151, 151, 142, 133, 130, 130, 110, 106, 87, 83, 80, 80, 73, 64, 63, 61, 42, 42, 38, 38, 37, 37, 36, 26, 25, 19, 18, 16, 15, 15, 15, 12, 11, 11, 9, 8, 8, 8, 7, 7, 6, 6, 6, 6, 5, 4, 4, 4, 3, 3, 3, 2, 2, 1, 0];
  var chunkCount = 10;
  var currentPage = 1;
  var commentsBoxEls = document.querySelectorAll('.comments-box');
  var pgCount = Math.ceil(commentsBoxEls.length / chunkCount);
  var pgWrapperEl = document.getElementsByClassName('pagination')[0];
  var seeMoreBtn = document.getElementsByClassName('see-more-comments')[0];
  var boxWrapper = document.getElementsByClassName('comments-box-wrapper')[0];

  if (!pgWrapperEl) {
    return false;
  }

  var documentFragment = document.createDocumentFragment();
  var tmpDivPrev = document.createElement("div");
  tmpDivPrev.classList.add('pagination__item');
  tmpDivPrev.textContent = 'Previous';
  tmpDivPrev.setAttribute('data-page', 'prev');
  tmpDivPrev.addEventListener('click', handlePgChange, false);
  documentFragment.appendChild(tmpDivPrev);

  for (var i = 1; i <= pgCount; i++) {
    var tmpDiv = document.createElement("div");
    tmpDiv.classList.add('pagination__item');
    tmpDiv.textContent = i;

    if (i === currentPage) {
      tmpDiv.classList.add('active');
    }

    tmpDiv.setAttribute('data-page', i);
    tmpDiv.addEventListener('click', handlePgChange, false);
    documentFragment.appendChild(tmpDiv);
  }

  var tmpDivNext = document.createElement("div");
  tmpDivNext.classList.add('pagination__item');
  tmpDivNext.textContent = 'Next';
  tmpDivNext.setAttribute('data-page', 'next');
  tmpDivNext.addEventListener('click', handlePgChange, false);
  documentFragment.appendChild(tmpDivNext);
  pgWrapperEl.appendChild(documentFragment);
  seeMoreBtn.addEventListener('click', function () {
    currentPage++;
    changePage(false, true);
  }, false);

  function handlePgChange(e) {
    var pageNum = e.target.dataset.page;

    if (parseInt(pageNum) && currentPage === parseInt(pageNum)) {
      return false;
    }

    currentPage = pageNum === 'prev' ? --currentPage : pageNum === 'next' ? ++currentPage : parseInt(pageNum);
    changePage();
  }

  function changePage() {
    var isFirstInit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var leaveOld = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var pgDisabled = pgWrapperEl.querySelector('.disabled');
    pgDisabled && pgDisabled.classList.remove('disabled');

    if (currentPage === pgCount) {
      pgWrapperEl.lastChild.classList.add('disabled');
      seeMoreBtn && seeMoreBtn.classList.remove('active');
    } else {
      seeMoreBtn && !seeMoreBtn.classList.contains('active') && seeMoreBtn.classList.add('active');
    }

    if (currentPage === 1) {
      pgWrapperEl.firstChild.classList.add('disabled');
    }

    if (!isFirstInit) {
      if ('scrollBehavior' in document.documentElement.style) {
        boxWrapper.scrollIntoView({
          block: 'start'
        });
      } else {
        boxWrapper.scrollIntoView(false);
      }
    }

    pgWrapperEl.querySelector('.active').classList.remove('active');
    pgWrapperEl.querySelector(".pagination__item[data-page=\"".concat(currentPage, "\"]")).classList.add('active');
    commentsBoxEls.forEach(function (item, i) {
      if (i >= currentPage * chunkCount - chunkCount && i < currentPage * chunkCount) {
        item.style.display = 'block';
      } else {
        if (!leaveOld) {
          item.style.display = 'none';
        }
      }

      if (isFirstInit) {
        item.querySelector('.u-actions .count').innerHTML = countHelp[i];
        item.querySelectorAll('.u-actions .btn').forEach(function (action) {
          action.addEventListener('click', function (e) {
            var iconStr = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNTUwIiBoZWlnaHQ9IjIwNDgiIGZpbGw9IiM0YzZlZjUiIHZpZXdCb3g9IjEyMSAwIDE1NTAgMjA0OCI+PHBhdGggZD0iTTE2NzEgNjk0YzAgMjYuNjY3LTkuMzMzIDQ5LjMzMy0yOCA2OGwtNzI0IDcyNC0xMzYgMTM2Yy0xOC42NjcgMTguNjY3LTQxLjMzMyAyOC02OCAyOHMtNDkuMzMzLTkuMzMzLTY4LTI4bC0xMzYtMTM2LTM2Mi0zNjJjLTE4LjY2Ny0xOC42NjctMjgtNDEuMzMzLTI4LTY4czkuMzMzLTQ5LjMzMyAyOC02OGwxMzYtMTM2YzE4LjY2Ny0xOC42NjcgNDEuMzMzLTI4IDY4LTI4czQ5LjMzMyA5LjMzMyA2OCAyOGwyOTQgMjk1IDY1Ni02NTdjMTguNjY3LTE4LjY2NyA0MS4zMzMtMjggNjgtMjhzNDkuMzMzIDkuMzMzIDY4IDI4bDEzNiAxMzZjMTguNjY3IDE4LjY2NyAyOCA0MS4zMzMgMjggNjh6Ii8+PC9zdmc+';

            if (e.target.classList.contains('btn__comment')) {
              iconStr = 'data:image/svg+xml;base64,PHN2ZyBpZD0iaWNvbi1zcGlubmVyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciDQogICAgIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj4NCiAgICA8c3R5bGU+DQogICAgICAgICNpY29uLXNwaW5uZXIgew0KICAgICAgICAgICAgZmlsbDogIzRjNmVmNTsNCiAgICAgICAgICAgIGFuaW1hdGlvbjogcm90YXRlIDJzIGxpbmVhciBpbmZpbml0ZTsNCiAgICAgICAgfQ0KICAgICAgICBAa2V5ZnJhbWVzIHJvdGF0ZSB7DQogICAgICAgICAgICAxMDAlIHsNCiAgICAgICAgICAgIHRyYW5zZm9ybTogcm90YXRlKDM2MGRlZyk7DQogICAgICAgICAgICB9DQogICAgICAgIH0NCiAgICA8L3N0eWxlPg0KICAgIDxwYXRoIGQ9Ik0zMDQgNDhjMCAyNi41MS0yMS40OSA0OC00OCA0OHMtNDgtMjEuNDktNDgtNDggMjEuNDktNDggNDgtNDggNDggMjEuNDkgNDggNDh6bS00OCAzNjhjLTI2LjUxIDAtNDggMjEuNDktNDggNDhzMjEuNDkgNDggNDggNDggNDgtMjEuNDkgNDgtNDgtMjEuNDktNDgtNDgtNDh6bTIwOC0yMDhjLTI2LjUxIDAtNDggMjEuNDktNDggNDhzMjEuNDkgNDggNDggNDggNDgtMjEuNDkgNDgtNDgtMjEuNDktNDgtNDgtNDh6TTk2IDI1NmMwLTI2LjUxLTIxLjQ5LTQ4LTQ4LTQ4UzAgMjI5LjQ5IDAgMjU2czIxLjQ5IDQ4IDQ4IDQ4IDQ4LTIxLjQ5IDQ4LTQ4em0xMi45MjIgOTkuMDc4Yy0yNi41MSAwLTQ4IDIxLjQ5LTQ4IDQ4czIxLjQ5IDQ4IDQ4IDQ4IDQ4LTIxLjQ5IDQ4LTQ4YzAtMjYuNTA5LTIxLjQ5MS00OC00OC00OHptMjk0LjE1NiAwYy0yNi41MSAwLTQ4IDIxLjQ5LTQ4IDQ4czIxLjQ5IDQ4IDQ4IDQ4IDQ4LTIxLjQ5IDQ4LTQ4YzAtMjYuNTA5LTIxLjQ5LTQ4LTQ4LTQ4ek0xMDguOTIyIDYwLjkyMmMtMjYuNTEgMC00OCAyMS40OS00OCA0OHMyMS40OSA0OCA0OCA0OCA0OC0yMS40OSA0OC00OC0yMS40OTEtNDgtNDgtNDh6Ii8+DQo8L3N2Zz4=';
            }

            var imgWrapperDiv = document.createElement('div');
            var newImgEL = document.createElement('img');
            newImgEL.src = iconStr;
            newImgEL.alt = 'icon';
            var posInfo = e.target.getBoundingClientRect();
            imgWrapperDiv.style.width = posInfo.width + 'px';
            imgWrapperDiv.style.height = posInfo.height + 'px';
            imgWrapperDiv.appendChild(newImgEL);
            e.target.parentNode.replaceChild(imgWrapperDiv, e.target);
          }, false);
        });
      }
    });
  }

  changePage(true);
};

exports.default = _default;

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(datcCallback) {
  var _vWrapper$getAttribut;

  var vWrapper = document.getElementsByClassName('video__inner-wrapper')[0];
  var datcTimer = (_vWrapper$getAttribut = vWrapper.getAttribute('data-datc-timer')) !== null && _vWrapper$getAttribut !== void 0 ? _vWrapper$getAttribut : 1887;
  var EMBED_CODE_ID = null; // const isPortraitMode = window.matchMedia("(orientation: portrait)").matches
  // const isLandscapeMode = window.matchMedia("(orientation: landscape)").matches
  // if (isPortraitMode) {
  //     EMBED_CODE_ID = document.querySelector('.video.portrait').id
  // } else if (isLandscapeMode) {
  //     EMBED_CODE_ID = document.querySelector('.video.landscape').id
  // }

  EMBED_CODE_ID = document.querySelector('.video').id;
  if (!EMBED_CODE_ID) return;
  var vidalyticsPlayerAPI = null;

  function initializePlayerAPI() {
    var player = getPlayer();

    if (player._player) {
      vidalyticsPlayerAPI = player;
      onPlayerAPIAvailableCallback();
      return;
    }

    setTimeout(initializePlayerAPI, 100);
  }

  initializePlayerAPI();

  function getPlayer() {
    var embeds = (window._vidalytics || {}).embeds || {};

    if (embeds[EMBED_CODE_ID]) {
      return embeds[EMBED_CODE_ID].player || {};
    }

    return {};
  }

  function onPlayerAPIAvailableCallback() {
    var datcEl = function datcEl() {
      return document.querySelector('main.hidden');
    };

    if (datcEl()) {
      vidalyticsPlayerAPI._player.addEventHandler('onTimeChanged', function () {
        if (datcEl() && vidalyticsPlayerAPI.getCurrentVideoTime() > parseInt(datcTimer)) {
          datcEl().classList.remove('hidden');
          datcCallback && datcCallback();
        }
      }, false);
    }
  }
};

exports.default = _default;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var reviewsData = [{
  heading: "“... after i'm finished I'm in such a peaceful state —more content, more happy, more joyful…”",
  name: 'Nathan Stiglick',
  video: 'xEfYJOcrJf0'
}, {
  heading: "...It's crazy, it's like magic for real. It's almost like the universe opens up to you, you'd think clearer, my thought pattern is different, I'm less tired and drained.",
  name: 'Hajara Bey',
  video: 'tTdPMhVVZwk'
}, {
  heading: "...For me, the program itself is just so easy to follow. It's choose as you will, based on what you need.",
  name: 'Tom Smigielski',
  video: 'usM96x0bj6s'
}];

var _default = function _default() {
  var runReviewsFunc = function runReviewsFunc(reviewsWrapper) {
    if (typeof reviewsWrapper === 'undefined' || reviewsWrapper === null) {
      return false;
    }

    var itemsToLoad = parseInt(reviewsWrapper.dataset.initialCardsCount);
    var cardTemplate = document.querySelector('.review-card.example');
    var modal = document.getElementsByClassName('dialog-overlay')[0];
    var reviewVideo = modal.querySelector('.review-video');
    var iframeOptions = {
      enablejsapi: 1,
      autoplay: 1,
      modestbranding: 1,
      controls: 0,
      showinfo: 0,
      rel: 0,
      hd: 1,
      wmode: 'transparent',
      cc_load_policy: 1
    };
    var IframeOptionsStr = Object.entries(iframeOptions).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      return key + '=' + value;
    }).join('&amp;');
    modal.querySelector('.close-icon').addEventListener('click', function (e) {
      e.stopPropagation();
      modal.classList.remove('active');
      reviewVideo.src = '';
    });

    var getYoutubeThumb = function getYoutubeThumb(insertId) {
      var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'mqdefault';
      return "https://img.youtube.com/vi/".concat(insertId, "/").concat(size, ".jpg");
    };

    var offset = 0;

    var loadCards = function loadCards() {
      var limit = offset + itemsToLoad;
      var newData = reviewsData.slice(offset, limit);
      var cardElements = [];

      var _loop = function _loop(i) {
        var templateClone = cardTemplate.cloneNode(true);
        templateClone.addEventListener('click', function () {
          reviewVideo.src = "https://www.youtube.com/embed/".concat(newData[i].video, "?").concat(IframeOptionsStr);
          modal.classList.add('active');
        });
        var videoThumbEl = templateClone.querySelector('.video-thumb');
        videoThumbEl.src = getYoutubeThumb(newData[i].video);
        videoThumbEl.setAttribute('data-video', getYoutubeThumb(newData[i].video));
        templateClone.querySelector('.name').innerHTML = newData[i].name;
        templateClone.querySelector('.desc').innerHTML = newData[i].heading;
        offset += 1;
        templateClone.classList.remove('example');
        cardElements.push(templateClone);
      };

      for (var i = 0; i < newData.length; i++) {
        _loop(i);
      }

      reviewsWrapper.append.apply(reviewsWrapper, cardElements);
    };

    loadCards();
  };

  var hasHiddenContent = function hasHiddenContent() {
    return document.querySelector('.main.hidden');
  };

  var reviewsWrappers = document.querySelectorAll('.review-card-wrapper');

  if (hasHiddenContent()) {
    window.addEventListener("datc-complete", function () {
      for (var i = 0; i < reviewsWrappers.length; i++) {
        runReviewsFunc(reviewsWrappers[i]);
      }
    });
  } else {
    for (var i = 0; i < reviewsWrappers.length; i++) {
      runReviewsFunc(reviewsWrappers[i]);
    }
  }
};

exports.default = _default;

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _default = function _default() {
  var datcCallback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  // YouTube API stuff
  var j = document.createElement("script"),
      f = document.getElementsByTagName("script")[0];
  j.src = "//www.youtube.com/iframe_api";
  j.async = true;
  f.parentNode.insertBefore(j, f);
  var videoItems = document.getElementsByClassName('video');
  var videoTime = 0;
  var timeUpdater = null;

  window.onYouTubeIframeAPIReady = function () {
    var _iterator = _createForOfIteratorHelper(videoItems),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var videoItem = _step.value;

        if (window.getComputedStyle(videoItem, null).display !== 'none') {
          var targetEl = videoItem.querySelector('.video__frame');
          var videoId = targetEl.getAttribute('data-video-id');
          var player = new YT.Player(targetEl, {
            height: '500',
            width: '900',
            videoId: videoId,
            playerVars: {
              autohide: 1,
              rel: 0,
              enablejsapi: 1,
              modestbranding: 0,
              showinfo: 0,
              controls: 0,
              hd: 1,
              border: 0,
              origin: document.location.hostname,
              wmode: 'transparent'
            },
            events: {
              onReady: onPlayerReady
            }
          });
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };

  var iframeObjects = [];

  function onPlayerReady(event) {
    var iframeObject = event.target;
    var videoContainer = iframeObject.getIframe().parentElement; // Push current iframe object to array

    iframeObjects.push(iframeObject);

    if (iframeObject.getIframe().closest('.exit-intent')) {
      window.addEventListener('exitpop-closed', function () {
        iframeObject.pauseVideo();
      }, false);
    }

    videoContainer.querySelector('.video__overlay').addEventListener('click', function () {
      if (iframeObject.getPlayerState() === 1 || iframeObject.getPlayerState() === 0) {
        iframeObject.pauseVideo();
        videoContainer.classList.contains('playing') && videoContainer.classList.remove('playing');
        return false;
      }

      if (iframeObject.getPlayerState() === 2 || iframeObject.getPlayerState() === 5) {
        iframeObjects.forEach(function (scopedIframeObject) {
          scopedIframeObject.pauseVideo();
          var scopedIframeElement = scopedIframeObject.getIframe();
          scopedIframeElement.classList.contains('playing') && scopedIframeElement.classList.remove('playing');
        }); // Play selected video

        iframeObject.playVideo();
        !videoContainer.classList.contains('playing') && videoContainer.classList.add('playing');
        init_DATC_timer(iframeObject);
        return false;
      }
    }, false);
  }

  function init_DATC_timer(player) {
    if (!player.getIframe().closest('.video__inner-wrapper').hasAttribute('data-datc-timer')) {
      return false;
    }

    var datcTime = player.getIframe().closest('.video__inner-wrapper').getAttribute('data-datc-timer');
    var datcEl = document.querySelector('main.hidden');

    if (!datcEl) {
      return false;
    }

    if (timeUpdater) clearInterval(timeUpdater);
    timeUpdater = setInterval(updateTime, 500);

    function updateTime() {
      var oldTime = videoTime;

      if (player.getPlayerState() === 1 && player.getCurrentTime) {
        videoTime = player.getCurrentTime();
      }

      if (videoTime !== oldTime) {
        if (videoTime >= datcTime) {
          clearInterval(timeUpdater);
          datcEl.classList.remove('hidden');
          this.dispatchEvent(new CustomEvent("datc-complete", {
            bubbles: true
          }));
          datcCallback();
        }
      }
    }
  }
};

exports.default = _default;

},{}],6:[function(require,module,exports){
"use strict";

var _vidalytics = _interopRequireDefault(require("../../js-modules/vidalytics"));

var _video = _interopRequireDefault(require("../../js-modules/video.js"));

var _videoTestimonials = _interopRequireDefault(require("../../js-modules/video-testimonials.js"));

var _testimonialsOpt = _interopRequireDefault(require("../../js-modules/testimonials-opt.js"));

var _exitIntent = _interopRequireDefault(require("../../js-modules/exit-intent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

window.addEventListener('DOMContentLoaded', function () {
  (0, _video.default)();
  (0, _vidalytics.default)();
  (0, _videoTestimonials.default)();
  (0, _testimonialsOpt.default)();
  (0, _exitIntent.default)(0, 15, 4);
  var prePurchaseBtns = document.getElementsByClassName('btn__pre-purchase');
  var prePurchasePops = document.getElementsByClassName('pre-purchase-popup');

  var _iterator = _createForOfIteratorHelper(prePurchaseBtns),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var prePurchaseBtn = _step.value;
      prePurchaseBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var rndInt = randomIntFromInterval(0, 1);
        prePurchasePops[rndInt].classList.add('active');
        var closeBtb = prePurchasePops[rndInt].getElementsByClassName('close-btn')[0];

        if (closeBtb) {
          closeBtb.addEventListener('click', function () {
            prePurchasePops[rndInt].classList.remove('active');
          }, false);
        }
      });
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
});

function randomIntFromInterval(min, max) {
  // min and max included
  return Math.floor(Math.random() * (max - min + 1) + min);
}

},{"../../js-modules/exit-intent":1,"../../js-modules/testimonials-opt.js":2,"../../js-modules/vidalytics":3,"../../js-modules/video-testimonials.js":4,"../../js-modules/video.js":5}],7:[function(require,module,exports){
var stateIndex = 0;
var HISTORY = [];
var activeState;
var activeHistoryItem=false;
var index = 1;

function back(flag){
    if (history.state == 'B-1' || history.state == 'B-2' || history.state == 'B-3' || history.state == 'B-4'){
        activeState = HISTORY.length>0 ? 'back' : 'backAll'+flag;
        history.back();
    }
}

window.addEventListener('popstate', function(event){
    var his, r;
    
    if (activeHistoryItem){
        r = activeHistoryItem;
        
        activeHistoryItem = null;
        return afterCancel(r);
    }

    if (activeState=='backAll' || activeState=='backAll1'){
        if (event.state == 'B-1' || event.state == 'B-2' || event.state == 'B-3' || event.state == 'B-4'){
            history.back();
        }else{
            if (activeState == 'backAll1'){
                activeState = 'backAll';
                history.back();
            }else{
                activeState = null;
            }
        }
        return;
    }

    if (activeState=='back'){
        if (history.state == 'B-1' || history.state == 'B-3'){
            return;
        }
    }

    // voltando
    if ( (activeState == 'B-2' && event.state == 'B-1') || (activeState == 'B-4' && event.state == 'B-3')){
        if (HISTORY.length>0){
            his = HISTORY[HISTORY.length-1]; // HISTORY.pop();
            
            if (his.callback){
                // cancela evento voltar
                activeHistoryItem = his; //faz com que chame afterCancel();
                history.go(1);
                return;
            }
        } else {
            return back(1);
        }
    } else if (event.state == 'B-1' || event.state == 'B-3'){
        //  frente;
        history.back();
    }
    
    activeState = event.state;
});

function afterCancel(his){
    // chama a função back registrada
    var r = his.callback();

    if (r!==false){
        HISTORY.remove(his);
    }else{
        pushState(his.id);
    }
}

function pushState(id){
    history.pushState('B-' + index, id, '');
    history.pushState('B-' + (index+1), id, '');
    activeState = 'B-' + (index + 1);

    index = index==1 ? 3 : 1;
}

back();

var BrowserBackButton = {
    on: function(id, callback) {
        if (arguments.length==1){
            callback = id;
            id = stateIndex++;
        }
        
        pushState(id);
    
        HISTORY.push({
            callback: callback,
            id: id
        });
    },

    off:function(id) {
        var i;
        var callback = typeof(id)!='function' ? null : id;
        
        if (!callback){
            for (i = 0; i < HISTORY.length; i++){
                if (HISTORY[i].id == id){
                    callback = HISTORY[i].callback;
                    break;
                }
            }
        }

        if (callback) {
            for (i = 0; i < HISTORY.length; i++){
                if (HISTORY[i].callback===callback){                    
                    HISTORY.splice(i, 1);
                    break;
                }
            }
        }
    }
};

module.exports = BrowserBackButton;



},{}],8:[function(require,module,exports){
(function (global){(function (){
"use strict";function isObject(e){var t=typeof e;return null!=e&&("object"==t||"function"==t)}function unwrapExports(e){return e&&e.__esModule?e.default:e}function createCommonjsModule(e,t){return t={exports:{}},e(t,t.exports),t.exports}function getRawTag(e){var t=hasOwnProperty.call(e,symToStringTag$1),n=e[symToStringTag$1];try{e[symToStringTag$1]=void 0;var o=!0}catch(e){}var r=nativeObjectToString.call(e);return o&&(t?e[symToStringTag$1]=n:delete e[symToStringTag$1]),r}function objectToString(e){return nativeObjectToString$1.call(e)}function baseGetTag(e){return null==e?void 0===e?undefinedTag:nullTag:symToStringTag&&symToStringTag in Object(e)?_getRawTag(e):_objectToString(e)}function isObjectLike(e){return null!=e&&"object"==typeof e}function isSymbol(e){return"symbol"==typeof e||isObjectLike_1(e)&&_baseGetTag(e)==symbolTag}function toNumber(e){if("number"==typeof e)return e;if(isSymbol_1(e))return NAN;if(isObject_1(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=isObject_1(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(reTrim,"");var n=reIsBinary.test(e);return n||reIsOctal.test(e)?freeParseInt(e.slice(2),n?2:8):reIsBadHex.test(e)?NAN:+e}function debounce(e,t,n){function o(t){var n=c,o=d;return c=d=void 0,b=t,v=e.apply(o,n)}function r(e){return b=e,m=setTimeout(l,t),h?o(e):v}function i(e){var n=e-b,o=t-(e-p);return g?nativeMin(o,f-n):o}function a(e){var n=e-p,o=e-b;return void 0===p||n>=t||n<0||g&&o>=f}function l(){var e=now_1();if(a(e))return u(e);m=setTimeout(l,i(e))}function u(e){return m=void 0,y&&c?o(e):(c=d=void 0,v)}function s(){var e=now_1(),n=a(e);if(c=arguments,d=this,p=e,n){if(void 0===m)return r(p);if(g)return m=setTimeout(l,t),o(p)}return void 0===m&&(m=setTimeout(l,t)),v}var c,d,f,v,m,p,b=0,h=!1,g=!1,y=!0;if("function"!=typeof e)throw new TypeError(FUNC_ERROR_TEXT$1);return t=toNumber_1(t)||0,isObject_1(n)&&(h=!!n.leading,f=(g="maxWait"in n)?nativeMax(toNumber_1(n.maxWait)||0,t):f,y="trailing"in n?!!n.trailing:y),s.cancel=function(){void 0!==m&&clearTimeout(m),b=0,c=p=d=m=void 0},s.flush=function(){return void 0===m?v:u(now_1())},s}function throttle(e,t,n){var o=!0,r=!0;if("function"!=typeof e)throw new TypeError(FUNC_ERROR_TEXT);return isObject_1(n)&&(o="leading"in n?!!n.leading:o,r="trailing"in n?!!n.trailing:r),debounce_1(e,t,{leading:o,maxWait:t,trailing:r})}function addWheelListener(e,t,n){_addWheelListener(e,support,t,n),"DOMMouseScroll"==support&&_addWheelListener(e,"MozMousePixelScroll",t,n)}function removeWheelListener(e,t,n){_removeWheelListener(e,support,t,n),"DOMMouseScroll"==support&&_removeWheelListener(e,"MozMousePixelScroll",t,n)}function _addWheelListener(e,t,n,o){e[_addEventListener](prefix+t,"wheel"==support?n:function(e){!e&&(e=window.event);var t={originalEvent:e,target:e.target||e.srcElement,type:"wheel",deltaMode:"MozMousePixelScroll"==e.type?0:1,deltaX:0,deltaY:0,deltaZ:0,clientX:e.clientX,clientY:e.clientY,preventDefault:function(){e.preventDefault?e.preventDefault():e.returnValue=!1},stopPropagation:function(){e.stopPropagation&&e.stopPropagation()},stopImmediatePropagation:function(){e.stopImmediatePropagation&&e.stopImmediatePropagation()}};return"mousewheel"==support?(t.deltaY=-.025*e.wheelDelta,e.wheelDeltaX&&(t.deltaX=-.025*e.wheelDeltaX)):t.deltaY=e.detail,n(t)},o||!1)}function _removeWheelListener(e,t,n,o){e[_removeEventListener](prefix+t,n,o||!1)}function detectEventModel(e,t){e&&e.addEventListener?(_addEventListener="addEventListener",_removeEventListener="removeEventListener"):(_addEventListener="attachEvent",_removeEventListener="detachEvent",prefix="on"),support=t?"onwheel"in t.createElement("div")?"wheel":void 0!==t.onmousewheel?"mousewheel":"DOMMouseScroll":"wheel"}function ExitIntent(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=_extends({},{debug:!1,maxDisplays:99999,eventThrottle:200,showAfterInactiveSecondsDesktop:60,showAfterInactiveSecondsMobile:40,showAgainAfterSeconds:10,yOffset:50,scrollOffset:200,useScrollOnDesktop:!1,onExitIntent:function(){}},e),n=!1,o=function(){for(var e=arguments.length,n=Array(e),o=0;o<e;o++)n[o]=arguments[o];if(t.debug){var r;(r=console).log.apply(r,["[exit-intent-mobile]"].concat(n))}},r=0,i=throttle_1(function(){!n&&r<t.maxDisplays&&(o("display onExitIntent",++r),t.onExitIntent(),r>=t.maxDisplays&&f())},1e3*t.showAgainAfterSeconds,{trailing:!1}),a=void 0;isDesktop&&(o("register mouseleave for desktop"),a=document.body.addEventListener("mouseout",throttle_1(function(e){e instanceof MouseEvent&&e.clientY<t.yOffset&&null==e.relatedTarget&&"select"!==e.target.nodeName.toLowerCase()&&(o("mouseout"),i())},t.eventThrottle),!1));var l=isDesktop?t.showAfterInactiveSecondsDesktop:t.showAfterInactiveSecondsMobile;o("timeoutOnDevice",l);var u=void 0,s=function(){void 0!==l?(void 0!==u&&(o("clearTimeout()"),window.clearTimeout(u)),u=window.setTimeout(function(){o("display after timeout"),i()},1e3*l)):o("display disabled")};s();var c=[],d=function(e,n){o("registering event for restartTimer",e,n);var r=throttle_1(function(e){o("throttled listener",e),s()},t.eventThrottle),a=null;a="scroll"===e?function(e){myScroll()<-scrollOffset&&(o("scroll"),i()),r(e)}:"mousemove"===e?function(e){e.clientY<t.yOffset&&(o("intent-to-leave"),i()),r(e)}:r;var l=n.addEventListener(e,a,!1);return c.push({event:e,listener:l,target:n}),l};isDesktop&&(t.useScrollOnDesktop&&d("scroll",window),d("mousemove",window),addWheelListener_1(window,function(e){throttle_1(function(e){o("throttled wheel listener",e),s()},t.eventThrottle)})),isTouchDevice&&(d("touchstart",document.body),d("touchend",document.body),d("touchmove",document.body),d("scroll",window));var f=function(){o("removeEvents",r),n=!0,a&&(document.body.removeEventListener("mouseleave",a),removeWheelListener_1(window,function(){o("removeWheelListener")})),c.forEach(function(e){var t=e.event,n=e.listener;e.target.removeEventListener(t,n)})};return f}var isObject_1=isObject,commonjsGlobal="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},freeGlobal="object"==typeof commonjsGlobal&&commonjsGlobal&&commonjsGlobal.Object===Object&&commonjsGlobal,_freeGlobal=freeGlobal,freeSelf="object"==typeof self&&self&&self.Object===Object&&self,root=_freeGlobal||freeSelf||Function("return this")(),_root=root,now=function(){return _root.Date.now()},now_1=now,Symbol$1=_root.Symbol,_Symbol=Symbol$1,objectProto=Object.prototype,hasOwnProperty=objectProto.hasOwnProperty,nativeObjectToString=objectProto.toString,symToStringTag$1=_Symbol?_Symbol.toStringTag:void 0,_getRawTag=getRawTag,objectProto$1=Object.prototype,nativeObjectToString$1=objectProto$1.toString,_objectToString=objectToString,nullTag="[object Null]",undefinedTag="[object Undefined]",symToStringTag=_Symbol?_Symbol.toStringTag:void 0,_baseGetTag=baseGetTag,isObjectLike_1=isObjectLike,symbolTag="[object Symbol]",isSymbol_1=isSymbol,NAN=NaN,reTrim=/^\s+|\s+$/g,reIsBadHex=/^[-+]0x[0-9a-f]+$/i,reIsBinary=/^0b[01]+$/i,reIsOctal=/^0o[0-7]+$/i,freeParseInt=parseInt,toNumber_1=toNumber,FUNC_ERROR_TEXT$1="Expected a function",nativeMax=Math.max,nativeMin=Math.min,debounce_1=debounce,FUNC_ERROR_TEXT="Expected a function",throttle_1=throttle,build=createCommonjsModule(function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.default=function(){return!("undefined"==typeof window||!("ontouchstart"in window||window.DocumentTouch&&"undefined"!=typeof document&&document instanceof window.DocumentTouch))||!("undefined"==typeof navigator||!navigator.maxTouchPoints&&!navigator.msMaxTouchPoints)},e.exports=t.default}),isTouchDevice=unwrapExports(build),wheel=addWheelListener,addWheelListener_1=addWheelListener,removeWheelListener_1=removeWheelListener,prefix="",_addEventListener,_removeEventListener,support;detectEventModel("undefined"!=typeof window&&window,"undefined"!=typeof document&&document),wheel.addWheelListener=addWheelListener_1,wheel.removeWheelListener=removeWheelListener_1;var asyncGenerator=function(){function e(e){this.value=e}function t(t){function n(r,i){try{var a=t[r](i),l=a.value;l instanceof e?Promise.resolve(l.value).then(function(e){n("next",e)},function(e){n("throw",e)}):o(a.done?"return":"normal",a.value)}catch(e){o("throw",e)}}function o(e,t){switch(e){case"return":r.resolve({value:t,done:!0});break;case"throw":r.reject(t);break;default:r.resolve({value:t,done:!1})}(r=r.next)?n(r.key,r.arg):i=null}var r,i;this._invoke=function(e,t){return new Promise(function(o,a){var l={key:e,arg:t,resolve:o,reject:a,next:null};i?i=i.next=l:(r=i=l,n(e,t))})},"function"!=typeof t.return&&(this.return=void 0)}return"function"==typeof Symbol&&Symbol.asyncIterator&&(t.prototype[Symbol.asyncIterator]=function(){return this}),t.prototype.next=function(e){return this._invoke("next",e)},t.prototype.throw=function(e){return this._invoke("throw",e)},t.prototype.return=function(e){return this._invoke("return",e)},{wrap:function(e){return function(){return new t(e.apply(this,arguments))}},await:function(t){return new e(t)}}}(),_extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},isDesktop=!isTouchDevice(),myScroll=function(){function e(){t=null,r=0}var t,n,o,r;return e(),function(){return n=window.scrollY,null!=t&&(r=n-t),t=n,clearTimeout(o),o=setTimeout(e,50),r}}();module.exports=ExitIntent;

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}]},{},[6]);
